import { render, staticRenderFns } from "./WedCommission.vue?vue&type=template&id=5014101c&scoped=true"
import script from "./WedCommission.vue?vue&type=script&lang=js"
export * from "./WedCommission.vue?vue&type=script&lang=js"
import style0 from "./WedCommission.vue?vue&type=style&index=0&id=5014101c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5014101c",
  null
  
)

export default component.exports